"use strict"

import { getCookie } from '../utils/cookie-handler';

export function init() {
    if (getCookie('_bo_logged_in')) {
        document.body.classList.add('user-logged-in');
    } else {
        document.body.classList.add('user-logged-out');
    }

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}
